module.exports = __webpack_public_path__ + "img/40_37_023_290.652cf1a0.jpg";